import type { FirebaseOptions } from 'firebase/app';

/**
 * For web, we need to configure the Firebase JS SDK (while native uses GoogleService-Info.plist / google-services.json).
 */
export const firebaseWebConfig: FirebaseOptions = {
  apiKey: process.env.EXPO_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.EXPO_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.EXPO_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.EXPO_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.EXPO_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.EXPO_PUBLIC_FIREBASE_APP_ID,
  databaseURL: process.env.EXPO_PUBLIC_FIREBASE_DATABASE_URL,
};

/**
 * Web Push (VAPID) public key from Firebase Console → Cloud Messaging → Web
 * configuration → "Web Push certificates". Required by `getToken` on web; web
 * push stays disabled (no-op) when this is absent.
 */
export const firebaseWebVapidKey = process.env.EXPO_PUBLIC_FIREBASE_VAPID_KEY;
